import styled from "styled-components"

const ApplicationContainer = styled.div`
  min-width: ${props => ['/delivery/shopify-integration', '/address-book'].includes(props.$pathname)  ? 'auto' : '1276px'};
`

export { ApplicationContainer }
